import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-shift-icon',
  templateUrl: './code-shift.component.html'
})
export class CodeShiftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
